import React from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { t } from '../i18n'
import { useDiscussions } from '../State/Discussions'
import { useUi } from '../State/Ui'
import { track } from '../Utils/analytics'
import { ChatIcon, HomeIcon, PhoneIcon, SearchIcon, StarIcon } from './Icons'
import { Lockup } from './Logo'

export const HOME_REFRESH_EVENT = 'instapres:home-refresh'

/* Početna tab and logo (spec 6): from elsewhere → Početna ("Sve") at the
   top; on Početna scrolled down → glide up; at the top → refresh. */
export function useHomeTap() {
  const location = useLocation()
  return (event) => {
    if (location.pathname !== '/') return // the link goes to "/" as a new screen, at the top
    event.preventDefault()
    if (window.scrollY > 4) window.scrollTo({ top: 0, behavior: 'smooth' })
    else window.dispatchEvent(new CustomEvent(HOME_REFRESH_EVENT))
  }
}

function NavItem({ to, label, icon: Icon, onClick, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {({ isActive }) => (
        <>
          <Icon size={24} active={isActive} />
          <span className="nav-label">{label}</span>
        </>
      )}
    </NavLink>
  )
}

/* Desktop: sticky left column (spec 4.1). */
export function LeftNav() {
  const homeTap = useHomeTap()
  const { openQr } = useUi()
  const discussions = useDiscussions().enabled
  return (
    <nav className="left-nav" aria-label="Instapres">
      <Link to="/" className="nav-logo" aria-label={t('common.logoLabel')} onClick={homeTap}>
        <Lockup icon={36} wordmark={25} />
      </Link>
      <NavItem to="/" end label={t('nav.home')} icon={HomeIcon} onClick={homeTap} />
      <NavItem to="/istrazi" label={t('nav.explore')} icon={SearchIcon} />
      <NavItem to="/moje-teme" label={t('nav.myTopics')} icon={StarIcon} />
      {discussions && <NavItem to="/diskusije" label={t('nav.discussions')} icon={ChatIcon} />}
      <button
        type="button"
        className="btn btn-dark get-app"
        onClick={() => {
          track('app_qr_open', { from: 'nav' })
          openQr()
        }}
      >
        <PhoneIcon size={18} />
        <span className="nav-label">{t('nav.getApp')}</span>
      </button>
    </nav>
  )
}

/* Mobile web: three tabs, no "Više" (spec 7.2); a fourth, Diskusije, while
   comments are on. */
export function BottomNav() {
  const homeTap = useHomeTap()
  const discussions = useDiscussions().enabled
  return (
    <nav className="bottom-nav" aria-label="Instapres">
      <NavItem to="/" end label={t('nav.home')} icon={HomeIcon} onClick={homeTap} />
      <NavItem to="/moje-teme" label={t('nav.myTopics')} icon={StarIcon} />
      {discussions && <NavItem to="/diskusije" label={t('nav.discussions')} icon={ChatIcon} />}
      <NavItem to="/istrazi" label={t('nav.explore')} icon={SearchIcon} />
    </nav>
  )
}
